/** Read selected file input as base64 for Hologram actions. */
export async function readSelectedFile(inputName) {
  const input = document.querySelector(`input[name="${inputName}"]`);
  const file = input?.files?.[0];
  if (!file) return null;

  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }

  return {
    name: file.name,
    content_b64: btoa(binary),
    size: file.size
  };
}
